if (!window.NCCartFulfillmentInitialized) {
  window.NCCartFulfillmentInitialized = true;

  const pickupAttributeKey = 'Preferred pickup date';
  const savePickupDate = (value) => {
    if (!window.routes?.cart_update_url) return;
    fetch(window.routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify({ attributes: { [pickupAttributeKey]: value } }),
    }).catch(() => {});
  };

  const validatePickupDate = (input, report = false) => {
    if (!input.value) {
      input.setCustomValidity('');
      return true;
    }

    const selected = new Date(`${input.value}T12:00:00`);
    const minDate = new Date();
    minDate.setHours(0, 0, 0, 0);
    minDate.setDate(minDate.getDate() + 5);

    let message = '';
    if (selected.getDay() !== 2) {
      message = input.dataset.ncErrorTuesday || 'Please select a Tuesday.';
    } else if (selected < minDate) {
      message = input.dataset.ncErrorReady || 'Choose a date at least 5 days away.';
    }

    input.setCustomValidity(message);
    if (report && message) input.reportValidity();
    return !message;
  };

  const refreshFulfillmentUI = () => {
    const rows = [...document.querySelectorAll('[data-nc-fulfillment]')];
    const hasPickup = rows.some((row) => row.dataset.ncFulfillment === 'pickup');
    const hasShipping = rows.some((row) => row.dataset.ncFulfillment === 'shipping');
    const wholesale = Boolean(document.querySelector('[data-nc-wholesale-source-list]'));
    const mixed = !wholesale && hasPickup && hasShipping;

    document.querySelectorAll('[data-nc-pickup-panel]').forEach((element) => {
      element.hidden = wholesale || !hasPickup;
    });
    document.querySelectorAll('[data-nc-mixed-warning], [data-nc-checkout-warning]').forEach((element) => {
      element.hidden = !mixed;
    });
    document.querySelectorAll('[data-nc-additional-checkout]').forEach((element) => {
      const scope = element.closest('#main-cart-footer, #CartDrawer') || document;
      const minimumBlocked = Boolean(scope.querySelector('[data-nc-wholesale-minimum-blocked="true"]'));
      element.hidden = mixed || minimumBlocked;
    });
    document.querySelectorAll('[data-nc-cart-checkout]').forEach((button) => {
      const scope = button.closest('#main-cart-footer, #CartDrawer') || document;
      const minimumBlocked = Boolean(scope.querySelector('[data-nc-wholesale-minimum-blocked="true"]'));
      const fulfillmentMissing = Boolean(scope.querySelector('[data-nc-fulfillment-select]:invalid'));
      const fulfillmentSaving = Boolean(scope.querySelector('[data-nc-fulfillment-select][data-nc-saving="true"]'));
      const empty = button.dataset.ncCartEmpty === 'true' || rows.length === 0;
      button.disabled = mixed || empty || minimumBlocked || fulfillmentMissing || fulfillmentSaving;
      const warningId = button.dataset.ncMixedWarningId;
      if (mixed && warningId) {
        button.setAttribute('aria-describedby', warningId);
      } else {
        button.removeAttribute('aria-describedby');
      }
    });

    const dateInputs = [...document.querySelectorAll('[data-nc-pickup-date]')];
    const minDate = new Date();
    minDate.setHours(0, 0, 0, 0);
    minDate.setDate(minDate.getDate() + 5);
    const minDateValue = [
      minDate.getFullYear(),
      String(minDate.getMonth() + 1).padStart(2, '0'),
      String(minDate.getDate()).padStart(2, '0'),
    ].join('-');

    dateInputs.forEach((input) => {
      input.required = !wholesale && hasPickup;
      input.min = minDateValue;
      validatePickupDate(input);
    });

    if (wholesale || !hasPickup) {
      const hadDate = dateInputs.some((input) => input.value);
      dateInputs.forEach((input) => {
        input.value = '';
        input.setCustomValidity('');
      });
      if (hadDate) savePickupDate('');
    }
  };

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest?.('[data-nc-pickup-date]');
      if (!input) return;

      event.stopPropagation();

      if (!validatePickupDate(input, true)) return;

      document.querySelectorAll('[data-nc-pickup-date]').forEach((other) => {
        if (other !== input) other.value = input.value;
      });
      savePickupDate(input.value);
    },
    true
  );

  document.addEventListener('change', async (event) => {
    const selected = event.target.closest?.('[data-nc-fulfillment-select]');
    if (!selected) return;

    const key = selected.dataset.ncFulfillmentKey;
    const peers = [...document.querySelectorAll('[data-nc-fulfillment-select]')].filter((field) => field.dataset.ncFulfillmentKey === key);
    const saved = selected.dataset.ncSavedValue || '';
    peers.forEach((field) => {
      field.value = selected.value;
      field.dataset.ncSaving = 'true';
      const status = field.parentElement.querySelector('[data-nc-fulfillment-status]');
      if (status) status.textContent = 'Saving fulfillment choice…';
    });
    refreshFulfillmentUI();

    try {
      const response = await fetch(window.routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({ attributes: { [key]: selected.value } }),
      });
      if (!response.ok) throw new Error('Cart update failed');
      peers.forEach((field) => {
        field.dataset.ncSavedValue = selected.value;
        const status = field.parentElement.querySelector('[data-nc-fulfillment-status]');
        if (status) status.textContent = 'Fulfillment choice saved.';
      });
    } catch (error) {
      peers.forEach((field) => {
        field.value = saved;
        const status = field.parentElement.querySelector('[data-nc-fulfillment-status]');
        if (status) status.textContent = 'Could not save this choice. Please select it again.';
      });
    } finally {
      peers.forEach((field) => { delete field.dataset.ncSaving; });
      refreshFulfillmentUI();
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('#NCWholesaleReviewForm');
    if (!form) return;
    const sourceList = document.querySelector('#main-cart-footer [data-nc-wholesale-source-list]');
    const preferences = [...(sourceList?.querySelectorAll('.nc-wholesale-cart-summary__group') || [])].map((group) => {
      const label = group.querySelector('h4')?.textContent?.trim();
      const choice = group.querySelector('[data-nc-fulfillment-select]')?.value
        || group.querySelector('input[type="hidden"][name^="attributes["]')?.value;
      return label && choice ? `${label}: ${choice}` : null;
    }).filter(Boolean);
    const body = form.querySelector('[data-nc-review-body]');
    if (body) body.value = `${body.defaultValue.trim()}\n\nFulfillment preferences:\n${preferences.join('\n')}`;
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => requestAnimationFrame(refreshFulfillmentUI));
  } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => requestAnimationFrame(refreshFulfillmentUI));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshFulfillmentUI, { once: true });
  } else {
    refreshFulfillmentUI();
  }

  const observer = new MutationObserver(() => requestAnimationFrame(refreshFulfillmentUI));
  observer.observe(document.documentElement, { childList: true, subtree: true });
}
